import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import messages from '../../../../locale/jsonMessages';
import EditCancellationPolicy from './EditCancellationPolicy';
import { restrictUrls } from '../../../../helpers/adminPrivileges';
export default async function action({ store, params, intl }) {

    const title = intl ? intl?.formatMessage(messages.editCancelPolicyTabTitle) : 'Edit Cancel Policy';

    // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/cancellation-policies', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    const id = !params.id || isNaN(params.id.toString()) ? 0 : Number(params.id);

    return {
        title,
        component: <AdminLayout><EditCancellationPolicy title={title} id={id} /></AdminLayout>,
    };
}
